interface MetricCardProps {
  value: string;
  label: string;
  bgColor?: string;
  borderColor?: string;
}

const MetricCard = ({ value, label, bgColor = "bg-gray-50", borderColor }: MetricCardProps) => {
  return (
    <div className={`${bgColor} rounded-lg p-6 shadow-sm ${borderColor ? `border ${borderColor}` : ""} flex-1`}>
      <div className="flex flex-col items-center justify-center text-center">
        <div className="text-3xl font-bold text-[#38571F] mb-2">{value}</div>
        <div className="text-sm text-[#666666]">{label}</div>
      </div>
    </div>
  );
};

interface SalesTotalChartProps {
  totalSales?: number;
  totalCompanies?: number;
  growthRate?: number;
}

export default function SalesTotalChart({ totalSales, totalCompanies, growthRate }: SalesTotalChartProps) {
  // 값 포맷팅
  const formatSales = (amount: number) => {
    return `${(amount / 100000000).toFixed(1)}억`;
  };

  const formatGrowth = (rate: number) => {
    const sign = rate > 0 ? "+" : "";
    return `${sign}${rate.toFixed(1)}%`;
  };

  return (
    <div className="flex gap-4 w-full">
      {/* 총 매출액 */}
      <MetricCard
        value={totalSales ? formatSales(totalSales) : "0"}
        label="총 매출액"
        bgColor="bg-[#D0E7AC33]"
        borderColor="border-[#D0E7AC]"
      />

      {/* 전체 업체 수 */}
      <MetricCard
        value={totalCompanies ? `${totalCompanies} 개` : "0"}
        label="전체 업체 수"
        bgColor="bg-[#EEEEEE33]"
        borderColor="border-[#D9D9D9]"
      />

      {/* 전년 동기간 대비 */}
      <MetricCard
        value={growthRate !== undefined ? formatGrowth(growthRate) : "0%"}
        label="전년 동기간 대비"
        bgColor={growthRate !== undefined && growthRate >= 0 ? "bg-[#4BA3F30D]" : "bg-[#FF86860D]"}
        borderColor={growthRate !== undefined && growthRate >= 0 ? "border-[#4BA3F3]" : "border-[#FF8686]"}
      />
    </div>
  );
}
